import {EventEmitter, Injectable, OnDestroy, OnInit} from "@angular/core";
import {AccionConfig, TablaConfig} from "../tabla-page/tabla-config";
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {MatTableDataSource} from "@angular/material/table";
import {takeUntil} from "rxjs/operators";
import {PasoWizard} from "../../../../interface/wizard-informacion.types";

@Injectable()
export abstract class BandejaBaseComponent<M> implements OnInit, OnDestroy {

    public abstract get tableConfig(): TablaConfig;

    public configuracionTabla: TablaConfig;
    public data: any[];
    public data$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    public datasource: MatTableDataSource<M> = new MatTableDataSource<M>([]);
    public actionElement: BehaviorSubject<M> = new BehaviorSubject<M>(undefined);
    public config: PasoWizard;
    public readOnly$: Observable<boolean> | BehaviorSubject<boolean> | Subject<boolean>;
    public actions: AccionConfig[] = [];
    public stop$ = new Subject<void>();
    public elementsDiligencia: M[];
    public readOnly: boolean;
    public elementsDiligenciaPadre: M[];
    public isUpdate: boolean;
    public actionTrigger: EventEmitter<Record<string, M>> = new EventEmitter<Record<string, M>>();

    constructor() { }

    ngOnInit(): void {
        this.configuracionTabla = this.tableConfig;
        this.data$.pipe(takeUntil(this.stop$)).subscribe(values => this.datasource = new MatTableDataSource<M>(values));
        this.creaAcciones();
    }

    public creaAcciones() {
        this.actions.push({accionId: 'EDIT', icon: 'edit'})
        if(!this.readOnly){
            this.actions.push({accionId: 'DELETE', icon: 'delete'})
        }
    }

    /**
     * Funcion que se ejecuta cuando dar clic en el boton Nuevo
     * @param origen: La seccion de origen
     */
    public onAdd(origen: string) {
        const res: Record<string, any> = {};
        res['ADD'] = {};
        this.actionTrigger.emit(res);
    }

    onAction(data: Record<string, M>) {
        if (Object.keys(data)[0] === 'FORMATO') {
            data['FORMATO']['formatos'] = this.config.formatos;
        }
        this.actionTrigger.emit(data);
    }

    ngOnDestroy(): void {
        this.stop$.next();
        this.stop$.complete();
    }
}
